import * as actionType from "./action";

/* External Links */
export function externalLinksReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_EXTERNAL_LINKS_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.GET_EXTERNAL_LINKS_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}

export function externalLinkReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_EXTERNAL_LINK_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.GET_EXTERNAL_LINK_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}

export function externalLinkOpReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.ADD_EXTERNAL_LINK_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.ADD_EXTERNAL_LINK_ERROR:
      return {
        ...state,
        response,
      };
    case actionType.MODIFY_EXTERNAL_LINK_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.MODIFY_EXTERNAL_LINK_ERROR:
      return {
        ...state,
        response,
      };
    case actionType.DELETE_EXTERNAL_LINK_SUCCESS:
      return {
        ...state,
        response,
      };
    case actionType.DELETE_EXTERNAL_LINK_ERROR:
      return {
        ...state,
        response,
      };
    default:
      return state;
  }
}
